// Auto-generated runtime values for WebSocketEventType from switch-core bindings
// Do not edit manually - run core/scripts/generate-ts-bindings.sh

export const WebSocketEventTypeValues = {
  CONNECTION_OPEN: "connection_open",
  CONNECTION: "connection",
  DISCONNECT: "disconnect",
  DISCONNECTED: "disconnected",
  AUTH_REQUIRED: "auth_required",
  MESSAGE_SEND: "message_send",
  MESSAGE_SENT: "message_sent",
  MESSAGE_ACK: "message_ack",
  MESSAGE_READ: "message_read",
  MESSAGE_DELIVERED: "message_delivered",
  MESSAGE_RECEIVED: "message_received",
  MESSAGE_SEND_FAILED: "message_send_failed",
  THREAD_JOIN_REQUEST: "thread_join_request",
  THREAD_CREATED: "thread_created",
  THREAD_UPDATED: "thread_updated",
  THREAD_DELETED: "thread_deleted",
  THREAD_JOINED: "thread_joined",
  THREAD_LEFT: "thread_left",
  COMMUNITY_CREATED: "community_created",
  COMMUNITY_UPDATED: "community_updated",
  COMMUNITY_DELETED: "community_deleted",
  COMMUNITY_JOINED: "community_joined",
  COMMUNITY_LEFT: "community_left",
  PING: "ping",
  PONG: "pong",
  ERROR: "error",
  THREAD_MEMBER_ADDED: "thread_member_added",
  THREAD_MEMBER_REMOVED: "thread_member_removed",
  USER_ADDED: "user_added",
  RECOVERY_ANNOUNCE: "recovery_announce",
  GROUP_METADATA_VERSION_CHANGED: "group_metadata_version_changed",
  GROUP_KEY_EPOCH_CHANGED: "group_key_epoch_changed",
  GROUP_TOMBSTONE: "group_tombstone",
  GROUP_MEMBER_ADDED: "group_member_added",
  GROUP_MEMBER_REMOVED: "group_member_removed",
  GROUP_MEMBERSHIP_VERSION_CHANGED: "group_membership_version_changed",
  RESYNC_REQUIRED: "resync_required",
  GROUP_MEMBERSHIP_RESYNC_REQUIRED: "group_membership_resync_required",
  COMMUNITY_MEMBER_ADDED: "community_member_added",
  COMMUNITY_MEMBER_REMOVED: "community_member_removed",
  SYSTEM_NOTIFICATION: "system_notification",
  SESSION_REVOKED: "session_revoked",
  CALL_JOIN: "call_join",
  CALL_JOINED: "call_joined",
  CALL_PEER_JOINED: "call_peer_joined",
  CALL_PEER_LEFT: "call_peer_left",
  CALL_OFFER: "call_offer",
  CALL_ANSWER: "call_answer",
  CALL_ICE_CANDIDATE: "call_ice_candidate",
  CALL_LEAVE: "call_leave",
  CALL_ERROR: "call_error",
} as const;

export type WebSocketEventTypeValue = (typeof WebSocketEventTypeValues)[keyof typeof WebSocketEventTypeValues];
